// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3oanb","itemTitle":"ClientEmergencyInfo_itemTitle__BcYoB","itemText":"ClientEmergencyInfo_itemText__2-Rvk"};